import BasicPillar from './BasicPillar.jsx'

/**
 * Revenue pillar.
 *
 * Currently just a thin wrapper over BasicPillar — all the shell
 * (header, goals list, sub-goals, "+ Add goal") is inherited. If this
 * pillar ever grows specialised HubSpot widgets or custom charts,
 * replace the one-liner with a bespoke component while still reading
 * from usePillarData('Revenue').
 */
export default function RevenuePillar() {
  return (
    <BasicPillar
      pillarId="revenue"
      description={
        'Q2 2026 revenue targets. Live — reads from the same KV store as /q2-goals.html.'
      }
    />
  )
}
